var _defs, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommunication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b7b7b7;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.25,1.88h8.91V9C9,9,7.8,9,6.62,9.07a2.7,2.7,0,0,0-1.34.47c-.75.51-1.44,1.12-2.28,1.78V9.06H1.25Zm8,.92H2.15V8.17H3.87L4,9.4a5.44,5.44,0,0,0,.66-.52,2.48,2.48,0,0,1,2.16-.75c.83.06,1.67,0,2.52,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.87,10V4.57H11.15V3.68h2.6v7.14H12v2.3c-.88-.69-1.61-1.32-2.39-1.86a2.24,2.24,0,0,0-1.14-.4c-1.09,0-2.18,0-3.31,0,.65-.9.65-.79,2.93-.94a4.08,4.08,0,0,1,3,1.35V10Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.37,4.14V5H3l0-.82Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.12,6.76H3.05V5.93H6.12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunication);
export default __webpack_public_path__ + "static/media/communication.e87b8db0ed893b929eb80213786ea32f.svg";
export { ForwardRef as ReactComponent };